import classNames from "classnames";

const ActivityIcon = ({ icon, unread }) => (
  <div className="mx-0.5 flex-shrink-0">
    <span
      className={classNames(
        "neeto-ui-bg-gray-200 neeto-ui-text-gray-600 neeto-ui-rounded-full neeto-molecules-activity-node-icon relative z-10 flex h-7 w-7 items-center justify-center p-1",
        {
          "neeto-ui-text-primary-600 neeto-ui-bg-primary-100": unread,
        }
      )}
    >
      {icon}
      {unread && (
        <span className="neeto-ui-rounded-full neeto-ui-bg-primary-800 absolute -end-0.5 -top-0.5 h-2 w-2" />
      )}
    </span>
  </div>
);

export default ActivityIcon;
